module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("45OEf"))).then(() => parcelRequire('d0iPb'));